import { render, staticRenderFns } from "./CreateBoardView.vue?vue&type=template&id=2829521f"
import script from "./CreateBoardView.vue?vue&type=script&lang=js"
export * from "./CreateBoardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports